exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".discoverSearchTagsChild[data-v-669e6db2]{width:100%!important}.disable-scroll[data-v-669e6db2]{overflow:hidden!important}#application-wrapper[data-v-669e6db2]{overflow:visible!important}.content-wrapper[data-v-669e6db2]{padding-top:80px;overflow-x:hidden;overflow-y:scroll;position:absolute;top:0;height:100%;width:100%}", ""]);

// exports
